export default __webpack_public_path__ + "static/media/icomoon.54165545.svg";